export default __webpack_public_path__ + "19d62b6b7e6e8ea505376e6c9755ea54.png";